import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WaitlistCountProvider } from "@/hooks/WaitlistCountContext";
import Index from "./pages/Index";
import Council from "./pages/Council";
import DumbIdeas from "./pages/DumbIdeas";
import Dumb from "./pages/Dumb";
import IdeaPage from "./pages/Idea";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <WaitlistCountProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/council" element={<Council />} />
            <Route path="/dumb-ideas" element={<DumbIdeas />} />
            <Route path="/dumb" element={<Dumb />} />
            <Route path="/idea/:id" element={<IdeaPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </WaitlistCountProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
